<template>
<!-- 企业雇主险支付页面 -->
<div class="main">
	<div class="title">{{info.productName}}</div>
	<Steps :current="2" style="margin:20px auto; width:700px;padding-left:116px">
		<Step title="查看详情"></Step>
		<Step title="确认信息"></Step>
		<Step title="支付"></Step>
	</Steps>
	<div class="order">
		<div class="order-title">订单信息</div>
		<Table :columns="columns" border :data="orderData">
			<template slot-scope="{ row, index }" slot="totalAmount">
				<div class="price">
					<p>
						<span class="price-label">订单金额：</span>
						<span class="price-value">{{row.totalAmount}}元</span>
					</p>
				</div>
			</template>
		</Table>
	</div>
	<div class="center fz16">当天24时前未完成支付订单，将自动关闭。</div>
	        <p class="mt10 center" >
          <Button
            type="primary"
            @click="toPay" 
            :loading="loading"
            >立即支付</Button
          >
        </p>
	<!-- <Row class="mt15">
		<Col span="9" offset="9">
		 
			<div class="pay" v-show="info.payUrl">
				<div class="code">
					<div id="qrcode" v-show="!loading"></div>
					<p>
					请使用
					微信 
					扫码支付
					</p>
				</div>
			</div>
			 
		</Col>
	</Row> -->
</div>
</template>
<script>
import QRCode from "qrcodejs2";
import Clipboard from "clipboard";
import UploadFile from '@/components/common/UploadFileImg'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{UploadFile},
	data() {
		return {
			productCode:this.$route.query.productCode||'QYTTGZZRXPCNEW',
			columns: [
				// {
				// 	title: "产品名称",
				// 	key: "productName",
				// 	slot: "productName"
				// },
				{
					title: "订单号",
					key: "orderNo"
				},
				{
					title: "订单创建时间",
					key: "createTime"
				},
				{
					title: "支付金额",
					slot: "totalAmount",
					width: 300
				}
			],
			orderData: [],
			info: {},
			clock: undefined,
			flag: true,
			use: true,
			payType: "",
			orderNo:this.$route.query.orderNo,
			qrcode:null,
			loading:false
		};
	},
	created() {
		this.getPayInfo();
		this.checkStatus()
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	methods: {
		/*获取支付信息*/
		async getPayInfo() {
			let res = await this.$axios.post('/cloud-cubic/queryPayInfo',{orderNo:this.orderNo})
			// let res = await this.$axios.post('/employerLiability/queryPayInfo',{orderNo:this.orderNo,productCode:this.productCode})
			this.info = res
			this.orderData=[res];
			this.getCode();
		},
		toPay(){
			// window.location.href = this.info.payUrl
				this.$Modal.confirm({
				title: '提示',
				render: (h) => {
					return h('div', [
						h('p',{},"即将跳转至第三方平台支付，是否确定跳转？"),
					 
					])
				},
				onOk: () => {
					window.location.href = this.info.payUrl
				},
				onCancel: () => {
				}
			});
		},
		// 获取二维码
		getCode() {
			if(!this.qrcode){
				this.$nextTick(() => {
					console.log(this.info.payUrl)
					this.qrcode = new QRCode("qrcode", {
						width: 200,
						height: 200, // 高度
						text: this.info.payUrl // 二维码内容
					});
				});
			}
		},
		/*检查支付状态*/
		checkStatus() {
			this.clock = setInterval(() => {
				if (this.flag) {
					this.flag = false;
					this.$postNo("/cloud-cubic/queryPayStatus",async res => {
						this.flag = true;
						if(res.data == 'PAID'){
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.orderNo
							});
							clearInterval(this.clock);
							window.location.href = `/haierProduct.html#/company-group-employer-yunlifang/order-detail/${this.info.policyId}`;
						}
					},
					{
						orderNo: this.orderNo
					});
				}
			}, 3000);
		},
		// 清除循环
		clearCheckStatus() {
			clearInterval(this.clock);
		},
		// 切换支付方式
		payTypeChange() {
			if (this.payType == "WECHATPAY") {
				this.getCode();
				this.checkStatus();
			}else if(this.clock){
				this.clearCheckStatus();
			}
		},
		// 复制
		copy() {
			let clipboard = new Clipboard(".copyBtn");
			clipboard.on("success", e => {
				this.toast("复制成功"); // 释放内存
				clipboard.destroy();
			});
			clipboard.on("error", e => {
				// 不支持复制
				this.alert("该浏览器不支持自动复制"); // 释放内存
				clipboard.destroy();
			});
		},
		// 上传成功
		handleSuccess(val){
			this.$set(this.info,'payVoucherUrl',val.url)
		},
		confirmUpload(){
			this.confirm('确定提交已上传凭证？',()=>{
				this.$axios.post('/employerLiability/updatePayInfo.json',{
					orderNo:this.orderNo,
					payVoucherUrl:this.info.payVoucherUrl,
					payVoucherRemarks:this.info.companyName+'+'+this.info.productName
				}).then(async res=>{
					// 回溯 停止录制
					await this.stopRecord({
						policy_id: this.orderNo
					});
					window.location.href=`/common.html#/pay-success/${this.orderNo}?phone=${res}`
				});
			})
		}
	}
};
</script>
<style scoped lang="less">
.main {
	padding: 20px 30px;
}
.order-title {
	font-size: 14px;
	margin-bottom: 10px;
}
.center {
	font-size: 25px;
	font-weight: bold;
	margin-top: 15px;
	color: #ff6600;
}
.pay {
	margin-top: 10px;
	display: flex;
	justify-content: center;
	text-align: center;
	width: 200px;
	margin-left: 45px;
}
.fz16{
	font-size: 16px;
}
.code > p {
	margin-top: 15px;
}
.price {
	font-size: 16px;
	&-label {
		width: 7em;
		display: inline-block;
		line-height: 2;
		text-align: right;
		font-size: 16px;
		&.small{
			width: 92px;
		}
	}
	&-value {
		color: red;
		font-size: 16px;
		&.disabled{
			color: #999;
			text-decoration: line-through;
		}
	}
}
.form {
	margin-top: 10px;
	font-size: 14px;
	&-label {
		width: 5em;
		display: inline-block;
		line-height: 2;
		text-align: right;
	}
	.red {
		color: red;
	}
}
.publicPay {
	.note {
		font-size: 12px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/IndexYun.vue